/**
 * AdminChatPanelBody — Master-Detail im Mobile-Bottom-Sheet (Admin-Modus)
 *
 * Wird vom ChatPanel gerendert, wenn der eingeloggte User ein Admin ist
 * und das Panel auf Mobile geöffnet wird.
 *
 * Layout:
 *   - Default: Konversations-Liste (volle Höhe des Sheet-Bodies)
 *   - Nach Auswahl: Thread mit "Zurück"-Button im Header
 *
 * Auf Desktop wird dieser Body NIE gerendert — die Bubble navigiert dort
 * direkt zur /admin-dashboard/support-Seite.
 */

import React, { useState } from 'react';
import { useAdminChatInbox } from '../../../hooks/useAdminChatInbox';
import { AdminConversationList } from './AdminConversationList';
import { AdminChatThread } from './AdminChatThread';

interface AdminChatPanelBodyProps {
  enabled: boolean;
}

export function AdminChatPanelBody({ enabled }: AdminChatPanelBodyProps): React.ReactElement {
  const inbox = useAdminChatInbox({ enabled });
  const [selectedId, setSelectedId] = useState<string | null>(null);

  // Master-Detail-Pattern: wenn Konversation ausgewählt → Thread, sonst Liste
  if (selectedId) {
    return (
      <div className="flex-1 min-h-0 flex flex-col">
        <AdminChatThread conversationId={selectedId} onBack={() => setSelectedId(null)} />
      </div>
    );
  }

  return (
    <div data-lenis-prevent className="flex-1 min-h-0 overflow-y-auto overscroll-contain scrollbar-styled touch-pan-y">
      <AdminConversationList
        conversations={inbox.conversations}
        selectedId={null}
        isLoading={inbox.isLoading}
        onSelect={setSelectedId}
      />
    </div>
  );
}
